import React from 'react';

import { Form, Input, InputNumber } from 'antd';
import { DatePicker } from 'antd';

export const getRows = (step, columns) => {
  const getInputs = (col) => {
    if (col.key === 'newsletter_number') {
      return <InputNumber min={0} max={1000} />;
    } else if (col.key === 'publicated_at') {
      return <DatePicker />;
    }

    return <Input />;
  };

  const rows: any[] = [];

  for (let i = 0; i < 5; i++) {
    rows.push(
      <tr key={i}>
        {columns.map((col, index) => {
          if (step === 1 && col.language === 'english') {
            return (
              <th
                key={index}
                scope="row"
                style={{
                  padding: '16px',
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                }}
              >
                <Form.Item
                  key={index}
                  name={col.key + i}
                  rules={[{ required: true, message: 'Input is required' }]}
                >
                  {getInputs(col)}
                </Form.Item>
              </th>
            );
          }
          if (step === 2 && col.language === 'french') {
            return (
              <th
                key={index}
                scope="row"
                style={{
                  padding: '16px',
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                }}
              >
                <Form.Item
                  key={index}
                  name={col.key + i}
                  rules={[{ required: true, message: 'Input is required' }]}
                >
                  {getInputs(col)}
                </Form.Item>
              </th>
            );
          }
          if (step === 3 && col.language === 'german') {
            return (
              <th
                key={index}
                scope="row"
                style={{
                  padding: '16px',
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                }}
              >
                <Form.Item
                  key={index}
                  name={col.key + i}
                  rules={[{ required: true, message: 'Input is required' }]}
                >
                  {getInputs(col)}
                </Form.Item>
              </th>
            );
          }

          return null;
        })}
      </tr>
    );
  }

  return rows;
};
